module.exports = __webpack_public_path__ + "img/step-4.b9bb937d.png";